import { render } from "./InputMathNumber.vue?vue&type=template&id=6a5c2629&scoped=true"
import script from "./InputMathNumber.vue?vue&type=script&lang=js"
export * from "./InputMathNumber.vue?vue&type=script&lang=js"

import "./InputMathNumber.vue?vue&type=style&index=0&id=6a5c2629&scoped=true&lang=css"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5c2629"]])

export default __exports__